var map = {
	"./bigball/BigBall_000.png": 868,
	"./bigball/BigBall_001.png": 869,
	"./bigball/BigBall_002.png": 870,
	"./bigball/BigBall_003.png": 871,
	"./bigball/BigBall_004.png": 872,
	"./bigball/BigBall_005.png": 873,
	"./bigball/BigBall_006.png": 874,
	"./bigball/BigBall_007.png": 875,
	"./bigball/BigBall_008.png": 876,
	"./bigball/BigBall_009.png": 877,
	"./bigball/BigBall_010.png": 878,
	"./bigball/BigBall_011.png": 879,
	"./bigball/BigBall_012.png": 880,
	"./bigball/BigBall_013.png": 881,
	"./bigball/BigBall_014.png": 882,
	"./bigball/BigBall_015.png": 883,
	"./bigball/BigBall_016.png": 884,
	"./bigball/BigBall_017.png": 885,
	"./bigball/BigBall_018.png": 886,
	"./bigball/BigBall_019.png": 887,
	"./bigball/BigBall_020.png": 888,
	"./bigball/BigBall_021.png": 889,
	"./bigball/BigBall_022.png": 890,
	"./bigball/BigBall_023.png": 891,
	"./bigball/BigBall_024.png": 892,
	"./bigball/BigBall_025.png": 893,
	"./black-ball.png": 77,
	"./blue-ball.png": 78,
	"./bonus_green/background.png": 894,
	"./bonus_green/ball_holder.png": 895,
	"./bonus_green/check_infoBar/check_000.png": 896,
	"./bonus_green/check_infoBar/check_001.png": 897,
	"./bonus_green/check_infoBar/check_002.png": 898,
	"./bonus_green/check_infoBar/check_003.png": 899,
	"./bonus_green/check_infoBar/check_004.png": 900,
	"./bonus_green/check_infoBar/check_005.png": 901,
	"./bonus_green/check_infoBar/check_006.png": 902,
	"./bonus_green/check_infoBar/check_007.png": 903,
	"./bonus_green/check_infoBar/check_008.png": 904,
	"./bonus_green/check_infoBar/check_009.png": 905,
	"./bonus_green/check_infoBar/check_010.png": 906,
	"./bonus_green/check_infoBar/check_011.png": 907,
	"./bonus_green/check_infoBar/check_012.png": 908,
	"./bonus_green/check_infoBar/check_013.png": 909,
	"./bonus_green/check_infoBar/check_014.png": 910,
	"./bonus_green/check_infoBar/check_015.png": 911,
	"./bonus_green/footer.png": 912,
	"./bonus_green/header.png": 913,
	"./bonus_green/hole.png": 914,
	"./bonus_green/number_picked.png": 915,
	"./bonus_yellow/background.png": 916,
	"./bonus_yellow/ball_holder.png": 917,
	"./bonus_yellow/check_infoBar/check_000.png": 918,
	"./bonus_yellow/check_infoBar/check_001.png": 919,
	"./bonus_yellow/check_infoBar/check_002.png": 920,
	"./bonus_yellow/check_infoBar/check_003.png": 921,
	"./bonus_yellow/check_infoBar/check_004.png": 922,
	"./bonus_yellow/check_infoBar/check_005.png": 923,
	"./bonus_yellow/check_infoBar/check_006.png": 924,
	"./bonus_yellow/check_infoBar/check_007.png": 925,
	"./bonus_yellow/check_infoBar/check_008.png": 926,
	"./bonus_yellow/check_infoBar/check_009.png": 927,
	"./bonus_yellow/check_infoBar/check_010.png": 928,
	"./bonus_yellow/check_infoBar/check_011.png": 929,
	"./bonus_yellow/check_infoBar/check_012.png": 930,
	"./bonus_yellow/check_infoBar/check_013.png": 931,
	"./bonus_yellow/check_infoBar/check_014.png": 932,
	"./bonus_yellow/check_infoBar/check_015.png": 933,
	"./bonus_yellow/footer.png": 934,
	"./bonus_yellow/header.png": 935,
	"./bonus_yellow/header_betin.png": 936,
	"./bonus_yellow/header_betole.png": 937,
	"./bonus_yellow/header_dualsoft.png": 938,
	"./bonus_yellow/header_elbet.png": 939,
	"./bonus_yellow/header_maxbet.png": 940,
	"./bonus_yellow/header_oktagon.png": 941,
	"./bonus_yellow/header_pinnbet.png": 942,
	"./bonus_yellow/header_soccer.png": 943,
	"./bonus_yellow/header_surebet247.png": 944,
	"./bonus_yellow/header_winbet.png": 945,
	"./bonus_yellow/hole.png": 946,
	"./bonus_yellow/number_picked.png": 947,
	"./brown-ball.png": 79,
	"./btn-background-black.png": 80,
	"./btn-background-green.png": 81,
	"./colorBetting.png": 948,
	"./color_betting/black.png": 949,
	"./color_betting/blue.png": 950,
	"./color_betting/brown.png": 951,
	"./color_betting/green.png": 952,
	"./color_betting/orange.png": 953,
	"./color_betting/purple.png": 954,
	"./color_betting/red.png": 955,
	"./color_betting/yellow.png": 956,
	"./combos-sr/201.png": 957,
	"./combos-sr/28.png": 958,
	"./combos-sr/6.png": 959,
	"./combos-sr/81.png": 960,
	"./combos/201.png": 214,
	"./combos/28.png": 215,
	"./combos/6.png": 216,
	"./combos/81.png": 217,
	"./drawnballs/black.png": 961,
	"./drawnballs/blue.png": 962,
	"./drawnballs/brown.png": 963,
	"./drawnballs/green.png": 964,
	"./drawnballs/orange.png": 965,
	"./drawnballs/purple.png": 966,
	"./drawnballs/red.png": 967,
	"./drawnballs/yellow.png": 968,
	"./drum/drum_loop_001.png": 969,
	"./drum/drum_loop_002.png": 970,
	"./drum/drum_loop_003.png": 971,
	"./drum/drum_loop_004.png": 972,
	"./drum/drum_loop_005.png": 973,
	"./drum/drum_loop_006.png": 974,
	"./drum/drum_loop_007.png": 975,
	"./drum/drum_loop_008.png": 976,
	"./drum/drum_loop_009.png": 977,
	"./drum/drum_loop_010.png": 978,
	"./drum/drum_loop_011.png": 979,
	"./drum/drum_loop_012.png": 980,
	"./drum/drum_loop_013.png": 981,
	"./drum/drum_loop_014.png": 982,
	"./drum/drum_loop_015.png": 983,
	"./drum/drum_loop_016.png": 984,
	"./drum/drum_loop_017.png": 985,
	"./drum/drum_loop_018.png": 986,
	"./drum/drum_loop_019.png": 987,
	"./drum/drum_loop_020.png": 988,
	"./drum/drum_loop_021.png": 989,
	"./drum/drum_loop_022.png": 990,
	"./drum/drum_loop_023.png": 991,
	"./drum/drum_loop_024.png": 992,
	"./drum/drum_loop_025.png": 993,
	"./drum/drum_loop_026.png": 994,
	"./drum/drum_loop_027.png": 995,
	"./drum/drum_loop_028.png": 996,
	"./drum/drum_loop_029.png": 997,
	"./drum/drum_loop_030.png": 998,
	"./drum/drum_loop_031.png": 999,
	"./drum/drum_loop_032.png": 1000,
	"./drum/drum_loop_033.png": 1001,
	"./drum/drum_loop_034.png": 1002,
	"./drum/drum_loop_035.png": 1003,
	"./drum/drum_loop_036.png": 1004,
	"./drum/drum_loop_037.png": 1005,
	"./drum/drum_loop_038.png": 1006,
	"./drum/drum_loop_039.png": 1007,
	"./drum/drum_loop_040.png": 1008,
	"./drum/drum_loop_041.png": 1009,
	"./drum/drum_loop_042.png": 1010,
	"./drum/frame.png": 1011,
	"./fast-arrow-down.png": 218,
	"./fast-arrow-right.png": 219,
	"./fast-choosen-bck.png": 144,
	"./flower.png": 1012,
	"./green-ball.png": 82,
	"./header-babaijebu.png": 220,
	"./header-intro.png": 1013,
	"./icons/192.png": 1014,
	"./icons/512.png": 1015,
	"./icons/96.png": 1016,
	"./icons/favicon.png": 1017,
	"./infobox/info_Box_000.png": 1018,
	"./infobox/info_Box_001.png": 1019,
	"./infobox/info_Box_002.png": 1020,
	"./infobox/info_Box_003.png": 1021,
	"./infobox/info_Box_004.png": 1022,
	"./infobox/info_Box_005.png": 1023,
	"./infobox/info_Box_006.png": 1024,
	"./infobox/info_Box_007.png": 1025,
	"./infobox/info_Box_008.png": 1026,
	"./infobox/info_Box_009.png": 1027,
	"./infobox/info_Box_010.png": 1028,
	"./infobox/info_Box_011.png": 1029,
	"./infobox/info_Box_012.png": 1030,
	"./infobox/info_Box_013.png": 1031,
	"./infobox/info_Box_014.png": 1032,
	"./infobox/info_Box_015.png": 1033,
	"./infobox/info_Box_016.png": 1034,
	"./infobox/info_Box_017.png": 1035,
	"./infobox/info_Box_018.png": 1036,
	"./infobox/info_Box_019.png": 1037,
	"./infobox/info_Box_020.png": 1038,
	"./infobox/info_Box_021.png": 1039,
	"./infobox/info_Box_022.png": 1040,
	"./infobox/info_Box_023.png": 1041,
	"./infobox/info_Box_024.png": 1042,
	"./infobox/info_Box_025.png": 1043,
	"./infobox/info_Box_026.png": 1044,
	"./infobox/info_Box_027.png": 1045,
	"./infobox/info_Box_028.png": 1046,
	"./infobox/info_Box_029.png": 1047,
	"./infobox/info_Box_030.png": 1048,
	"./infobox/info_Box_031.png": 1049,
	"./infobox/info_Box_032.png": 1050,
	"./infobox/info_Box_033.png": 1051,
	"./infobox/info_Box_034.png": 1052,
	"./intro.jpg": 1053,
	"./jackpot/001.png": 1054,
	"./jackpot/002.png": 1055,
	"./jackpot/003.png": 1056,
	"./jackpot/004.png": 1057,
	"./jackpot/005.png": 1058,
	"./jackpot/006.png": 1059,
	"./jackpot/007.png": 1060,
	"./jackpot/008.png": 1061,
	"./jackpot/009.png": 1062,
	"./jackpot/010.png": 1063,
	"./jackpot/011.png": 1064,
	"./jackpot/012.png": 1065,
	"./jackpot/013.png": 1066,
	"./jackpot/014.png": 1067,
	"./jackpot/015.png": 1068,
	"./jackpot/016.png": 1069,
	"./jackpot/017.png": 1070,
	"./jackpot/018.png": 1071,
	"./jackpot/019.png": 1072,
	"./kvacica.png": 83,
	"./loader-1.png": 1073,
	"./loading.png": 1074,
	"./orange-ball.png": 84,
	"./purple-ball.png": 85,
	"./red-ball.png": 86,
	"./regular_game/background.png": 1075,
	"./regular_game/ball_holder.png": 1076,
	"./regular_game/check_infoBar/check_000.png": 1077,
	"./regular_game/check_infoBar/check_001.png": 1078,
	"./regular_game/check_infoBar/check_002.png": 1079,
	"./regular_game/check_infoBar/check_003.png": 1080,
	"./regular_game/check_infoBar/check_004.png": 1081,
	"./regular_game/check_infoBar/check_005.png": 1082,
	"./regular_game/check_infoBar/check_006.png": 1083,
	"./regular_game/check_infoBar/check_007.png": 1084,
	"./regular_game/check_infoBar/check_008.png": 1085,
	"./regular_game/check_infoBar/check_009.png": 1086,
	"./regular_game/check_infoBar/check_010.png": 1087,
	"./regular_game/check_infoBar/check_011.png": 1088,
	"./regular_game/check_infoBar/check_012.png": 1089,
	"./regular_game/check_infoBar/check_013.png": 1090,
	"./regular_game/check_infoBar/check_014.png": 1091,
	"./regular_game/check_infoBar/check_015.png": 1092,
	"./regular_game/footer.png": 1093,
	"./regular_game/header.png": 1094,
	"./regular_game/header_betin.png": 1095,
	"./regular_game/header_betole.png": 1096,
	"./regular_game/header_dualsoft.png": 1097,
	"./regular_game/header_elbet.png": 1098,
	"./regular_game/header_maxbet.png": 1099,
	"./regular_game/header_oktagon.png": 1100,
	"./regular_game/header_pinnbet.png": 1101,
	"./regular_game/header_soccer.png": 1102,
	"./regular_game/header_surebet247.png": 1103,
	"./regular_game/header_winbet.png": 1104,
	"./regular_game/hole.png": 1105,
	"./regular_game/number_picked.png": 1106,
	"./risk.png": 1107,
	"./video.png": 1108,
	"./weager/Background_image.png": 1109,
	"./weager/Button.png": 1110,
	"./weager/Button_pressed.png": 1111,
	"./weager/Buy_Ticket.png": 1112,
	"./weager/Buy_Ticket_pressed.png": 1113,
	"./weager/Lower_Raise/Button_Higher.png": 1114,
	"./weager/Lower_Raise/Button_Higher_minus.png": 1115,
	"./weager/Lower_Raise/Button_Higher_plus.png": 1116,
	"./weager/Lower_Raise/Button_Higher_pressed.png": 1117,
	"./weager/Lower_Raise/Button_Lower.png": 1118,
	"./weager/Lower_Raise/Button_Lower_pressed.png": 1119,
	"./weager/Lower_Raise/Value_Holder.png": 1120,
	"./weager/Page_left.png": 1121,
	"./weager/Page_right.png": 1122,
	"./weager/Repeat.png": 1123,
	"./weager/Shuffle.png": 1124,
	"./weager/Stake_Holder.png": 1125,
	"./weager/Tab_normal.png": 1126,
	"./weager/Tab_pressed.png": 1127,
	"./weager/ball-chosen-holder.png": 1128,
	"./weager/balls/color/black.png": 1129,
	"./weager/balls/color/blue.png": 1130,
	"./weager/balls/color/brown.png": 1131,
	"./weager/balls/color/green.png": 1132,
	"./weager/balls/color/orange.png": 1133,
	"./weager/balls/color/purple.png": 1134,
	"./weager/balls/color/red.png": 1135,
	"./weager/balls/color/yellow.png": 1136,
	"./weager/balls/normal/LB_1.png": 1137,
	"./weager/balls/normal/LB_2.png": 1138,
	"./weager/balls/normal/LB_3.png": 1139,
	"./weager/balls/normal/LB_4.png": 1140,
	"./weager/balls/normal/LB_5.png": 1141,
	"./weager/balls/normal/LB_6.png": 1142,
	"./weager/balls/normal/LB_7.png": 1143,
	"./weager/balls/normal/LB_8.png": 1144,
	"./yellow-ball.png": 87
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 867;


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img \.(gif|png|jpe?g|svg)$/
// module id = 867
// module chunks = 2